// Element
import ELEMENT from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// flex 布局库
import 'flex.css'
// 组件
import '@/components'
// svg 图标
import '@/assets/svg-icons'
// 过滤器
import d2VueFiltersDate from '@d2-admin/filters-dayjs/src/main'
// 功能插件
import pluginError from '@/plugin/error'
import pluginLog from '@/plugin/log'
import pluginOpen from '@/plugin/open'

import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'

// import contentmenu from 'v-contextmenu'
// import 'v-contextmenu/dist/index.css'

// 已废弃
// import authorize from '@/plugin/authorize'
import { globalMixin } from '@/plugin/authorize/global.js'

export default {
  async install (Vue, options) {
    // 设置为 false 以阻止 vue 在启动时生成生产提示
    // https://cn.vuejs.org/v2/api/#productionTip
    Vue.config.productionTip = false
    // 当前环境
    Vue.prototype.$env = process.env.NODE_ENV
    // 当前的 baseUrl
    Vue.prototype.$baseUrl = process.env.BASE_URL
    // 当前版本
    Vue.prototype.$version = process.env.VUE_APP_VERSION
    // 构建时间
    Vue.prototype.$buildTime = process.env.VUE_APP_BUILD_TIME
    // Element
    Vue.use(ELEMENT, { size: 'mini' })
    // 过滤器 日期模块
    Vue.use(d2VueFiltersDate)
    //  // 权限验证
    //  Vue.use(authorize)
    // //右键菜单
    // Vue.use(contentmenu)
    // 插件
    Vue.use(pluginError)
    Vue.use(pluginLog)
    Vue.use(pluginOpen)
    Vue.use(Donut)
    Vue.mixin(globalMixin)
  }
}
